import { FormItem, FormWrapper, SearchInput, SearchInputProps } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const SearchBoxWrapper = styled.div`
max-width: 100%;
min-width: 100%;
`;

type SearchProps = Pick<SearchInputProps, "placeholder" | "value" | "onChange"> & {
    onSearchInputChange: (query: string) => void;
};

export const SearchSummitUser: React.FC<SearchProps> = ({
    onSearchInputChange,
    value,
    onChange,
    placeholder
}) => {
    const { t } = useTranslation();

    return (
        <SearchBoxWrapper>
            <FormWrapper layout="vertical">
                <FormItem label={t("summit.form.search.label", { defaultValue: "User" })}>
                    <SearchInput

                        onSearchInputChange={(searchQuery: string) => {
                            onSearchInputChange(searchQuery);
                        }}
                        placeholder={placeholder || t("summit.form.search.placeholder", {
                            defaultValue: "Name, email, or username…",
                            ns: "melco-common",
                        })}
                        value={value}
                        onChange={onChange}
                    />
                </FormItem>
            </FormWrapper>
        </SearchBoxWrapper>
    );
};
